import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=adffcafe&lang=pug&"
import script from "./ContentLayout.vue?vue&type=script&lang=js&"
export * from "./ContentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports